"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var review_profile_controller_1 = __importDefault(require("../../../../signup/student/review-profile.controller"));
var review_student_signup_html_1 = __importDefault(require("./../../../../signup/student/review-student-signup.html"));
var states_1 = require("../../../../common/constants/states");
var time_1 = require("../../../../common/helpers/time");
var CreateStudentController = /** @class */ (function () {
    function CreateStudentController(UsersModel, FlashService, SchoolsModel, $uibModal, UserService, $state, CreateStudentService) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.SchoolsModel = SchoolsModel;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.CreateStudentService = CreateStudentService;
        this.schoolCodeValid = false;
        this.submitted = false;
        this.create_order = false;
        this.loadingSchools = false;
        this.states = states_1.States;
        this.updateDOB = this.updateDOB.bind(this);
        this.currentUser = UserService.getCurrentUser();
        var defaults = {
            schoolcode: this.currentUser.school.code,
            school: this.currentUser.school,
            last_minute_text_reminders: "N",
            guardian_last_minute_text_reminders: "N",
        };
        this.formData = __assign(__assign({}, defaults), CreateStudentService.get());
        this.submitStudent = this.submitStudent.bind(this);
    }
    /**
     * Return the student's age in days based on their DOB
     */
    CreateStudentController.prototype.getStudentAge = function () {
        if (!this.formData.dob) {
            return 10000000;
        }
        var dob = (0, time_1.parseMMDDYYYYDate)(this.formData.dob);
        return (0, time_1.differenceInDays)(new Date(), dob);
    };
    /**
     * Is the student under 18 years old?
     */
    CreateStudentController.prototype.studentIsAMinor = function () {
        return this.getStudentAge() < 6570;
    };
    /**
     * Is the student under 21 years old?
     */
    CreateStudentController.prototype.studentUnder21 = function () {
        return this.getStudentAge() < 7670;
    };
    /**
     * Force the school code to be upper case and only allow alphanumerics
     */
    CreateStudentController.prototype.formatCode = function () {
        this.formData.schoolcode = this.formData.schoolcode
            .replace(/[^a-z0-9\s]/gi, "")
            .toUpperCase();
    };
    CreateStudentController.prototype.updateDOB = function (newDate) {
        this.formData.dob = newDate.selected[0];
    };
    CreateStudentController.prototype.submitStudent = function () {
        var _this = this;
        if (this.submitted === true) {
            return;
        }
        var student = structuredClone(this.formData);
        this.modalInstance.submitted = true;
        var dob = (0, time_1.formatDateTime)((0, time_1.parseMMDDYYYYDate)(student.dob), "YYYY-MM-DD");
        var request = {
            firstname: student.firstname,
            lastname: student.lastname,
            username: student.username,
            dob: dob,
            email: student.email,
            schoolcode: this.currentUser.school.code,
            phone: student.phone,
            driving_experience: student.driving_experience,
            pickuplocation: null,
            parent: null,
            gender: null,
            lead_id: student.lead_id,
        };
        if (student.hasOwnProperty("gender") && student.gender) {
            request.gender = student.gender;
        }
        if (request.gender === null) {
            delete request.gender;
        }
        if (student.hasOwnProperty("pickuplocation") &&
            student.pickuplocation.street &&
            student.pickuplocation.city &&
            student.pickuplocation.state &&
            student.pickuplocation.zip) {
            request.pickuplocation = student.pickuplocation;
        }
        if (student.hasOwnProperty("parent") &&
            student.parent.firstname &&
            student.parent.lastname &&
            student.parent.email &&
            student.parent.phone) {
            request.parent = student.parent;
        }
        if (request.pickuplocation === null) {
            delete request.pickuplocation;
        }
        if (request.parent === null) {
            delete request.parent;
        }
        if (!request.schoolcode) {
            delete request.schoolcode;
        }
        if (!request.username) {
            delete request.username;
        }
        this.UsersModel.adminCreateStudent(request)
            .then(function (response) {
            _this.modalInstance.submitted = false;
            _this.modalInstance.dismiss("cancel");
            if (_this.create_order === true) {
                _this.$state.go("drivecoach.admin.students.view.createorder", {
                    userId: response.student.id,
                });
            }
            else {
                _this.$state.go("drivecoach.admin.students.verification");
            }
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (Error) {
            _this.modalInstance.submitted = false;
        });
    };
    CreateStudentController.prototype.reviewProfile = function () {
        var _this = this;
        this.modalInstance = this.$uibModal.open({
            animation: true,
            template: review_student_signup_html_1.default,
            controller: review_profile_controller_1.default,
            controllerAs: "vm",
            size: "sm",
            resolve: {
                student: this.formData,
                submit: function () { return _this.submitStudent; },
            },
        });
    };
    return CreateStudentController;
}());
CreateStudentController.$inject = [
    "UsersModel",
    "FlashService",
    "SchoolsModel",
    "$uibModal",
    "UserService",
    "$state",
    "CreateStudentService",
];
exports.default = CreateStudentController;
